<template>
  <appointment-management
    ref="AppointmentManagement"
    main-page-title="Manejo de Citas"
    searchTextPlaceholder="Número de SIE, Cita o Pre-registro"
    :main-page-routes="['Inicio', 'Estudiante', 'Citas', 'Manejo de Citas']"
    :academic-years="academicYears"
    :can-show-service-filter="true"
    :cancel-appointment="cancelAppointment"
    :change-center-appointment="changeCenterAppointment"
    :companies="companiesData"
    :deny-appointment="denyAppointment"
    :full-profile="fullProfileData"
    :get-academic-years="getAcademicYears"
    :get-appointment-filters="getAppointmentFilters"
    :get-appointments="getAppointments"
    :get-appointments-specialists="getAppointmentsSpecialists"
    :get-centers="getCenters"
    :get-discipline-types="getDisciplineTypes"
    :get-districts="getDistricts"
    :get-municipalities="getMunicipalities"
    :get-reasons-appointment-status="getReasonsApointmentStatus"
    :get-reasons-appointment-status-detail="getReasonsApointmentStatusDetail"
    :get-schools="getSchools"
    :get-type-places="getTypePlaces"
    :has-evaluation-document="hasEvaluationDocument"
    :has-permissions="hasPermissions"
    :need-reason-detail="true"
    :on-download-evaluation-document="onDownloadEvaluationDocument"
    :on-download-pei="onDownloadPei"
    :on-download-referral-sheet="onDownloadReferralSheet"
    :can-show-confirm-appointment="true"
    :on-confirm-appointment="onConfirmAppointment"
    :can-show-denied-appointment="true"
    :on-denied-appointment="onDeniedAppointment"
    :can-show-recoordinate-appointment="true"
    :on-recoordinate-appointment="onRecoordinateAppointment"
    :on-add-comment="onAddComment"
    :on-validate-submitted-invoice="onValidateSubmittedInvoice"
    :allowed-pilot-plan-user="allowedPilotPlanUser"
    :on-get-contact-information="getContactInformation"
    :on-get-additional-info="getAppointmentAdditionalInfo"
    :on-get-therapies="getAppointmentTherapies"
    :is-provider="isProvider"
    has-toggle
    :on-set-as-attended="setAsAttended"
    :show-diagnostic-impression="true"
    show-comments-history
    show-add-comments
    @redirect-comment-history="handleRedirectCommentHistory"
  />
</template>

<script>
import { AppointmentManagement } from "appointment-management";
import appointmentServices from "@/services/api/appointment.api.js";
import locationServices from "@/services/api/location.api.js";
import codeServices from "@/modules/common/code.api.js";
import companyServices from "@/services/api/company.api.js";
import academicYearServices from "@/modules/common/academicyear.api.js";
import reportServices from "@/services/report.js";
import generalApi from "@/services/pei/general.js";
import { mapGetters } from "vuex";
import alertMixin from "@/mixin/alert.mixin";
import pilotPlanRoles from "@/utils/constants/pilotPlanRoles.js";
import store from "@/store/index";
import userRoles from "@/utils/constants/userRoles.js";
import commentTypes from '@/utils/constants/comment/commentTypes';
import studentService from '@/services/student.js';
import objectToFormData from "object-to-formdata";

export default {
  name: "AppointmentManagementWrapper",
  components: {
    AppointmentManagement
  },
  mixins: [alertMixin],
  data: () => ({
    messages: []
  }),
  computed: {
    ...mapGetters("$_user", ["fullProfile", "companies"]),
    academicYears() {
      return academicYearServices;
    },
    fullProfileData() {
      return this.userProfile;
    },
    companiesData() {
      return [];
    },
    allowedPilotPlanUser() {
      if (pilotPlanRoles.includes(this.userRole) && !this.userPilotPlan) {
        return false;
      }
      return true;
    },
    userPilotPlan() {
      return store.getters["$_user/pilotPlan"];
    },
    isProvider() {
      return [
        userRoles.adminProvider,
        userRoles.adminProviderCenter,
        userRoles.provider,
        userRoles.assistantprovider
      ].includes(this.userRole);
    }
  },
  methods: {
    hasPermissions(permission) {
      return this.$store.getters.HasPermission(permission);
    },
    getAppointmentFilters() {
      return appointmentServices.getAppointmentSearchInitialFilterValues();
    },
    getAppointments(filterProperties) {
      return appointmentServices.getAppointmentSearchData(filterProperties);
    },
    async getDistricts(data) {
      var response = await locationServices.getDistricts({
        AcademicYearId: data.AcademicYearId,
        CenterId: data.CenterId
      });
      return response.data;
    },
    async getSchools(data) {
      var response = await locationServices.getSchools({
        AcademicYearId: data.AcademicYearId,
        MunicipalityId: data.MunicipalityId
      });

      return response.data;
    },
    getAppointmentsSpecialists(data) {
      return companyServices.getSpecialists({
        academicYearId: data.academicYearId,
        companyId: data.companyId,
        pageSize: data.pageSize
      });
    },
    getCenters(filters) {
      return locationServices.getCenters(filters);
    },
    getMunicipalities(data) {
      return locationServices.getMunicipalities({
        AcademicYearId: data.AcademicYearId,
        DistrictId: data.DistrictId
      });
    },
    getTypePlaces(id) {
      return codeServices.getLocationTypes(id);
    },
    async getDisciplineTypes(filter) {
      var disciplineTypes = await codeServices.getDisciplineTypes({
        serviceTypeIds: [filter]
      });

      return { data: disciplineTypes };
    },
    getAcademicYears() {
      return academicYearServices.getAcademicYears();
    },
    getReasonsAppointmentStatus(filter) {
      return appointmentServices.getReasonsAppointmentStatus(filter);
    },
    cancelAppointment(model) {
      return appointmentServices.cancelAppointmentStatus(model);
    },
    changeCenterAppointment(clientAppointmentId, centerId) {
      return appointmentServices.changeCenterAppointment(
        clientAppointmentId,
        centerId
      );
    },
    getReasonsApointmentStatus(filter) {
      return appointmentServices.getReasonsAppointmentStatus(filter);
    },
    getReasonsApointmentStatusDetail(ReasonsApointmentStatusCd) {
      return appointmentServices.getStatusReasonDetails(
        ReasonsApointmentStatusCd
      );
    },
    denyAppointment(model) {
      return appointmentServices.denyAppointmentStatus(model);
    },
    async onDownloadReferralSheet(row) {
      if (row.studentReferralId) {
        await reportServices
          .downloadReferralReport(row.studentReferralId)
          .then(response => {
            generalApi.ConvertToBlob(response.data);
          });
      }
    },
    async onDownloadPei(row) {
      if (row.client_SieId) {
        await reportServices
          .getLatestSignedPeipReport(row.client_SieId)
          .then(res => {
            generalApi.documentDownloadReport(
              res.data.content,
              res.data.filename
            );
          });
      }
    },
    async onDownloadEvaluationDocument(row) {
      let clientAppointmentId = parseInt(
        row.formatedClientAppointmentId.replace("-", "")
      );

      await appointmentServices
        .getEvaluationDocument(clientAppointmentId)
        .then(response => {
          generalApi.ConvertToBlob(response.data[0]);
        })
        .catch(error => {
          let errorMessage =
            error.response && error.response.data
              ? error.response.data.message
              : "ha ocurrido un error inesperado.";
          this.ShowToast("Error", errorMessage, "error");
        });
    },
    async hasEvaluationDocument(row) {
      let clientAppointmentId = parseInt(
        row.formatedClientAppointmentId.replace("-", "")
      );

      await appointmentServices
        .getEvaluationDocument(clientAppointmentId)
        .then(response => {
          return response.data != null;
        })
        .catch(() => {
          return false;
        });
    },
    async onConfirmAppointment(model) {
      return await this.$ApiPost("/api/appointment/confirmappointment", model);
    },
    async onValidateSubmittedInvoice(model) {
      return await this.$ApiPost(
        "/api/appointment/validatesubmittedinvoice",
        model
      );
    },
    async onDeniedAppointment(model) {
      return await this.$ApiPost("/api/appointment/deniedappointment", model);
    },
    async onRecoordinateAppointment(model) {
      return await this.$ApiPost(
        "/api/appointment/recoordinateappointment",
        model
      );
    },
    async onAddComment(payload){     
       let formData = objectToFormData(
        { 
          studentSieId: payload.studentSie,
          categoryTypeId: commentTypes.ManejoCitas,        
          description: payload.comment
        }, { indices: true });
      
        if (payload.file) {
          formData.append("attachment", payload.file);
        }

      return await studentService.saveComment(formData);    
    },
    async setAsAttended(clientAppointmentId) {
      return await this.$ApiPut(
        `/api/appointment/setasattendance/${clientAppointmentId}`
      );
    },
    async getContactInformation(studentSieId, clientAppointmentId) {
      if (!studentSieId) {
        return await appointmentServices.getPublicPortalContactInformation(
          clientAppointmentId
        );
      }
      return await appointmentServices.getContactInformation(studentSieId);
    },
    async getAppointmentAdditionalInfo(clientAppointmentId) {
      return await appointmentServices.getAppointmentAdditionalInfo(
        clientAppointmentId
      );
    },
    async getAppointmentTherapies(clientAppointmentId) {
      return await appointmentServices.getAppointmentTherapies(
        clientAppointmentId
      );
    },
    handleRedirectCommentHistory(sieId) {
      if (!sieId) return;

      this.$refs.AppointmentManagement.persistData();
      this.$router.push({
        path: `/student/comments/commentshistory/${sieId}/${commentTypes.ManejoCitas}`
      });
    }
  },
  beforeRouteEnter(_, from, next) {
    const persistRoutes = ["student-menu"];
    next(async vm => {
      if (persistRoutes.some(x => x == from.name)) {
        vm.shouldRecovery = false;
        vm.$refs["AppointmentManagement"].shouldRecovery = false;
      } else {
        vm.$refs["AppointmentManagement"].shouldRecovery = true;
        vm.$refs["AppointmentManagement"].recoveryData();
      }
    });
  },
  mounted(){
    store.state.$_student.showSelectedStudent = false;
  }
};
</script>
